// extracted by mini-css-extract-plugin
export default {"popoverContent":"webpack-pages-StudyList-StudyListToolbar-components-MergeStudiesButton-module__popoverContent"};